// extracted by mini-css-extract-plugin
export default {"base":"v7pzz","avatar":"M37on","text":"RcNsx","remove":"R91oY","noAvatar":"OdHdL","noHandler":"H5Rqt","noFeatures":"ccAkd"};